import { atom } from 'jotai'

/**
 * Hand-off from the new-user onboarding dialog (treatment of
 * exp2605-onboarding-in-generation-panel) to the generator panel.
 *
 * - `prompt` carries the pre-baked first prompt to inject into the prompt
 *   input. Cleared by the generator after it consumes the value.
 * - `tooltipPending` keeps the generate-button tooltip visible until the user
 *   dismisses it (close icon) or presses generate. Cleared on either.
 *
 * In-memory only by design: the tooltip is a one-shot welcome bound to the
 * onboarding flow, and a refresh resets the whole flow anyway.
 */
export const onboardingFirstPromptAtom = atom<{
  prompt: string | null
  tooltipPending: boolean
}>({ prompt: null, tooltipPending: false })

/**
 * Set when the treatment flow redirects to the generator and wants the
 * onboarding dialogs opened *after* landing there. The imperative dialogs live
 * inside RootRuntimeInner's <Suspense>, so opening them before/during the route
 * transition orphans them when the boundary remounts. OnboardingPendingWatcher
 * consumes this once the generator route is mounted and stable.
 */
export const onboardingPendingAtom = atom(false)
